import React, { Fragment, ReactNode } from 'react';
import BgImage from '../Assets/techlawyered-bg.svg';
import TechLawyeredLogo from '../Assets/TeleCourt.png';
import LagosStateJudiciaryLogo from '../Assets/lsj-logo.svg';

interface Props {
  title: string;
  screenText: string;
  children: ReactNode;
}

const OnBoardingShell: React.FC<Props> = (props) => {
  return (
    <div className='w-full flex items-start h-screen relative'>
      <div className='bg-[rgba(53,30,20,1)] w-1/2 h-full relative hidden md:flex flex-col items-center justify-center py-12'>
        <div className='bg-[rgba(232,196,144,1)] w-[589px] h-full rounded-[30px]'>
          <div className='flex flex-col items-center justify-center h-full mt-[45px]'>
            <div className='flex gap-[14px]'>
              <img src={LagosStateJudiciaryLogo} alt='' height={90} width={80}/>
              <img src={TechLawyeredLogo} alt='' height={100} width={100} />
            </div>
            <div>
              <p className='text-[#222222] font-bold text-3xl text-center'>
                {props.title}
              </p>
              <p className='text-[#222222] font-normal text-xl text-center'>
                {props.screenText}
              </p>
            </div>
            <div>
              <img src={BgImage} alt='' className='w-[300px] h-full' />
            </div>
          </div>
        </div>
      </div>
      <Fragment>{props.children}</Fragment>
    </div>
  );
};

export default OnBoardingShell;
